import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { Card } from "primereact/card";

export default function InicioProfesores() {
  const navigate = useNavigate();

  const pageStyle = {
    minHeight: "100vh",
    width: "100%",
    background: "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%)",
    padding: "40px 20px",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const containerStyle = {
    width: "100%",
    maxWidth: "1200px",
    margin: "0 auto",
    textAlign: "center",
  };

  const badgeStyle = {
    display: "inline-block",
    padding: "10px 18px",
    borderRadius: "999px",
    background: "rgba(255,255,255,0.12)",
    color: "#ffffff",
    fontSize: "14px",
    fontWeight: 600,
    marginBottom: "18px",
  };

  const titleStyle = {
    color: "#ffffff",
    fontSize: "clamp(2rem, 5vw, 3.5rem)",
    fontWeight: 800,
    lineHeight: 1.1,
    margin: "0 0 16px 0",
  };

  const subtitleStyle = {
    maxWidth: "760px",
    margin: "0 auto 48px auto",
    color: "rgba(255,255,255,0.82)",
    fontSize: "clamp(1rem, 2vw, 1.15rem)",
    lineHeight: 1.7,
  };

  const cardStyle = {
    borderRadius: "24px",
    background: "rgba(255,255,255,0.08)",
    border: "1px solid rgba(255,255,255,0.12)",
    backdropFilter: "blur(8px)",
    WebkitBackdropFilter: "blur(8px)",
    boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
    height: "100%",
    overflow: "hidden",
  };

  const cardContentStyle = {
    padding: "0.5rem",
    textAlign: "left",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  };

  const iconStyle = {
    fontSize: "2.8rem",
    marginBottom: "18px",
    display: "block",
  };

  const cardTitleStyle = {
    color: "#ffffff",
    fontSize: "1.5rem",
    fontWeight: 700,
    margin: "0 0 14px 0",
  };

  const cardTextStyle = {
    color: "rgba(255,255,255,0.8)",
    fontSize: "1rem",
    lineHeight: 1.7,
    margin: "0 0 26px 0",
    flexGrow: 1,
  };

  const buttonCommonStyle = {
    border: "none",
    borderRadius: "14px",
    padding: "14px 22px",
    fontWeight: 700,
    width: "100%",
    justifyContent: "center",
  };

  return (
    <div style={pageStyle}>
      <div style={containerStyle}>
        <div style={badgeStyle}>Selecciona una opción</div>

        <h1 style={titleStyle}>¿Qué herramienta deseas usar?</h1>

        <p style={subtitleStyle}>
          Elige si quieres acceder a la herramienta de calificaciones o ir a la
          herramienta para crear una nueva entrada de blog.
        </p>

        <div className="grid justify-content-center">
          <div className="col-12 md:col-6 lg:col-5">
            <Card style={cardStyle}>
              <div style={cardContentStyle}>
                <span style={iconStyle}>📊</span>

                <h2 style={cardTitleStyle}>Herramienta de calificaciones</h2>

                <p style={cardTextStyle}>
                  Accede al sistema para consultar, gestionar o capturar
                  calificaciones de manera rápida, clara y organizada.
                </p>

                <Button
                  label="Ir a calificaciones"
                  icon="pi pi-chart-bar"
                  onClick={() => navigate("/Limpiador")}
                  style={{
                    ...buttonCommonStyle,
                    background: "#2563eb",
                    color: "#ffffff",
                  }}
                />
              </div>
            </Card>
          </div>

          <div className="col-12 md:col-6 lg:col-5">
            <Card style={cardStyle}>
              <div style={cardContentStyle}>
                <span style={iconStyle}>✍️</span>

                <h2 style={cardTitleStyle}>Entrada de blog</h2>

                <p style={cardTextStyle}>
                  Crea y redacta una nueva publicación para compartir noticias,
                  ideas, avisos o contenido importante dentro del blog.
                </p>

                <Button
                  label="Crear entrada de blog"
                  icon="pi pi-pencil"
                  onClick={() => navigate("/blog_entrada")}
                  style={{
                    ...buttonCommonStyle,
                    background: "#f97316",
                    color: "#ffffff",
                  }}
                />
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}